import { View } from 'react-native';

import { Box, HStack, VStack, theme } from '@squire/ui';

import { Skeleton } from '@/components/_shared/Skeleton';

import { styles } from './styles';
import type { ServiceGridSkeletonV2Props } from './types';

const ServiceGridSkeletonV2 = ({
  testID = 'service-grid-loading',
}: ServiceGridSkeletonV2Props) => {
  return (
    <View style={styles.container} testID={testID}>
      <VStack style={styles.servicesGrid}>
        {Array.from({ length: 5 }).map((_, index) => (
          <Box
            key={index}
            style={styles.card}
            testID={`service-skeleton-${index}`}
          >
            <VStack space={theme.spacing[4]}>
              <VStack space={theme.spacing[7]}>
                <Skeleton variant="text" width="30%" height={16} />
                <Skeleton variant="text" width="60%" height={20} />
              </VStack>

              <HStack space={theme.spacing[2]} style={styles.priceRow}>
                <Skeleton style={styles.priceSkeleton} />
                <Skeleton style={styles.buttonSkeleton} />
              </HStack>
            </VStack>
          </Box>
        ))}
      </VStack>
    </View>
  );
};

ServiceGridSkeletonV2.displayName = 'ServiceGridSkeletonV2';
export { ServiceGridSkeletonV2 };
